import { useFilters } from "features/filters/store";
import { Flex } from "@chakra-ui/react";
import { List } from "../List";
import { ActionButtons } from "../ActionButtons";
import { FiltroAcompanhamentoOperacional } from "../FiltroAcompanhamentoOperacional";
import { Planejamento } from "../../interfaces/Planejamento";
import FiltroRelatorioAderencia from "../Relatorios/partials/FiltroRelatorioAderencia";

type SideMenuProps = {
  planoOperacionalData: Planejamento,
  dataMapOS?: any
}

function SideMenu({ planoOperacionalData, dataMapOS }: SideMenuProps) {

  const { filters: { tabBarSessaoPlanejamentoOperacional, menuNameRelatorios } } = useFilters();

  return (
    <Flex flexDirection="column" width="100%" height="90%">
      {tabBarSessaoPlanejamentoOperacional === 'cadastros' && (
        <>
          <List
            planoOperacionalData={planoOperacionalData?.planosOperacionais}
            filtersData={planoOperacionalData?.filtrosAvancados}
          />
          <ActionButtons />
        </>
      )}
      {tabBarSessaoPlanejamentoOperacional === 'execucao-operacional' && (
        <FiltroAcompanhamentoOperacional dataMapOS={dataMapOS} filtrosAvancados={planoOperacionalData?.filtrosAvancados} />
      )}
      {tabBarSessaoPlanejamentoOperacional === 'relatorios' && menuNameRelatorios === 'Relatório de Aderência Operacional' && (
        <FiltroRelatorioAderencia filtrosAvancados={planoOperacionalData?.filtrosAvancados} />
      )}
    </Flex>
  );
}

export default SideMenu;
